import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useIsAuthenticated } from '@zapier/design-system-revenue/src/hooks';

import { companyTrialEndedBanner as CompanyTrialBannerEndedQuery } from './types/companyTrialEndedBanner';

export const useCompanyTrialEndedBannerQuery = gql`
  query companyTrialEndedBanner(
    $accountId: Int!
    $interval: BillingInterval!
    $type: String!
  ) {
    account(id: $accountId) {
      currentPlan: planV2 {
        id
        interval
        name
      }
      id
    }

    nextPlan: nextPlanV2(
      accountId: $accountId
      interval: $interval
      type: $type
    ) {
      id
      name
    }

    profile: currentUserV2 {
      id
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useData = ({ skip }: Props = {}) => {
  const { isAuthenticated } = useIsAuthenticated();
  const accountId = localStorage.getItem('currentAccountId');

  const { data, loading, error } = useQuery<CompanyTrialBannerEndedQuery>(
    useCompanyTrialEndedBannerQuery,
    {
      skip: skip || !isAuthenticated || !accountId,
      variables: {
        accountId: parseInt(accountId ?? ''),
        interval: 'year',
        type: 'Company',
      },
    }
  );

  const currentPlan = data?.account?.currentPlan;
  const nextPlan = data?.nextPlan;

  return {
    currentPlan: currentPlan
      ? {
          name: currentPlan.name,
        }
      : undefined,
    error: error
      ? 'There was an error fetching account information. Please try again.'
      : null,
    isLoading: loading,
    nextPlan:
      currentPlan && nextPlan
        ? {
            interval: currentPlan.interval,
            name: nextPlan.name,
          }
        : undefined,
    profileId: data?.profile?.id,
  };
};
